import React from 'react';

import { SelectPrizeForGhoreUI } from './SelectPrizeForGhoreUI'


//import { GhorePrizePage } from '../../components/GhorePrizePage'

import { DropdownWithUrl } from '../../elements/DropdownWithUrl'

import { Dropdown } from '../../elements/Dropdown'

export class SelectPrizeForGhore extends React.Component {

    constructor(props) {
        super(props);
        this.getDataUrl = "api/v1/GetGhore?offset=";
        this.className = "Ghore";


        this.state = {};
        this.state.isLoaded = false;
        this.state.mode = "table";

        this.state.data = [];
        this.state.data1 = [];
        this.state.data2 = [];

        this.onAddClick = this.onAddClick.bind(this);

        this.handleTextChange = this.handleTextChange.bind(this);
        this.onStartGhoreClick = this.onStartGhoreClick.bind(this);

        var token = localStorage.getItem('token');
        this.headers =
        {
            'Content-Type': 'application/json',
            'AuthorizationToken': token,
            'ghoreId': this.props.ghoreId

        };


        this.data2=[{id:"1" ,name:"شناسه ثابت"} ,{id:"2",name:"مرتب سازی براساس اعضا"}];
    }

    componentDidMount() {


        fetch('/api/v1/GetShortGhorePrize', {
            method: 'GET',
            headers: this.headers
        }).then(res => {
            this.status = res.status;

            res.json().then((result) => {
                //    console.log(result);
                this.data1 = result;
                this.setState({
                    isLoaded: true,
                    status: res.status
                });
                //   console.log(result);
            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //     console.log(error);
                    this.setState({
                        isLoaded: true,

                    });
                }
            );
        }
        );


    }

    handleTextChange(v, k) {
        this.state.data[k] = v;

    }

    onAddClick(e) {
        var id = this.state.data["ghorePrize"];


        const found = this.data1.find(element => element.id == id);


        if (found != null) {

            const found2 = this.state.data2.find(element => element.id == id);

            if (found2 != null) {
                alert("تکراری است");
                return;
            }



            this.state.data2.push(found);

            console.log(this.state.data2);
            this.setState({});
        }

        // expected output: 12


    }

    onStartGhoreClick() {

        if (this.state.data2.length == 0) {
            alert("هیچ جایزه  ای برای قرعه کشی انتخاب نشده است.");
            return;
        }



        var prizedata = [];

        console.log(this.state.data2);
        for (var i = 0; i < this.state.data2.length; i++) {
            var d = this.state.data2[i];
            prizedata.push({ ghorePrizeId: d.id, prizeName: d.name });
        }


        var data4 =
        {
            lotteryKind: this.state.data.lotteryKind,
            lotteryType: 2,

            isWeighted: true,

            ceremonyGhorePrizes: prizedata

        }

        console.log(prizedata);
        console.log(data4);

        console.log(JSON.stringify(data4));

        fetch('/api/v1/AddCeremony', {
            method: 'POST',
            body: JSON.stringify(data4),
            headers: this.headers
        }).then(res => {
            this.status = res.status;

            res.json().then((result) => {


                if (res.status == 200) {
                    if (typeof this.props.onAdd === "function") {
                        this.props.onAdd();

                    }
                }
                else
                {
                    alert(result.Value);

                }

                //   console.log(result);
            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //     consol);
                }
            );
        }
        );


        console.log("start ghorekeshi");
    }



    render() {
        if (!this.state.isLoaded) {
            return <div className="box-body"> در حال بارگذاری</div>;
        }


        return (<div className="container">
            <h1> انتخاب جوایز برای قرعه کشی </h1>
            <br />
            <Dropdown onChange={this.handleTextChange} Data={this.data1} label="نام جایزه" name="ghorePrize" ></Dropdown>
            <br/>
            <Dropdown onChange={this.handleTextChange} Data={this.data2} label="نوع مراسم" name="lotteryKind" ></Dropdown>
            <br/>
            <input type="button" value="اضافه کردن" onClick={this.onAddClick} className="btn btn-primary" />
            < SelectPrizeForGhoreUI data={this.state.data2} />

            <input type="button" value="آغاز قرعه کشی" onClick={this.onStartGhoreClick} className="btn btn-primary" />


        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/tables/selectPrizeForGhore/SelectPrizeForGhore.js